export default function FullscreenLoader() {
    return (
        <div className="fullscreen-loader">
            <div className="loader-content">
                <img
                    className="spinner"
                    src={process.env.PUBLIC_URL + "/Ellipse.svg"}
                    alt=""
                />
                <div className="loader-text">Загрузка...</div>
            </div>
        </div>
    );
}
